import { z } from 'zod';

/**
 * Контракт `POST /api/media/signed-url` — батч-генерация short-lived URL для R2-ключей.
 * Источник: `docs/architecture/api-contracts.md` §3.5.
 *
 * P-031 (анти-парсинг): publicly accessible URL'ы запрещены, всё через signed.
 * P-009: фото пользователя через этот эндпоинт НЕ ходит — они остаются на устройстве.
 */
export const MediaSignedUrlRequestSchema = z.object({
  keys: z.array(z.string()).min(1).max(50),
});

export type MediaSignedUrlRequest = z.infer<typeof MediaSignedUrlRequestSchema>;

export const MediaSignedUrlResponseSchema = z.object({
  urls: z.record(
    z.string(),
    z.object({
      url: z.string().url(),
      expiresAt: z.string().datetime(),
    }),
  ),
});

export type MediaSignedUrlResponse = z.infer<typeof MediaSignedUrlResponseSchema>;
